import React from 'react';
import '../../src/styles/Careers.css';

const jobs = [
  { title: 'DevOps Engineer', location: 'San Jose, CA' },
  { title: 'Frontend Developer', location: 'San Jose, CA' },
  { title: 'Creative Director', location: 'San Jose, CA' },
  { title: 'Regional Director', location: 'Orlando, FL' },
  { title: 'Area Operations Manager', location: 'Orlando, FL' },
  { title: 'Brand Ambassador', location: 'Orlando, FL' },
];



const Careers = () => {
  return (
    <>
      <div className="careers-section">
        <h2>Together, we can change the world</h2>
        <p>
          Our team of dedicated professionals are constantly searching for the best talent that share our vision
          for a brighter future. We are excited to welcome people to our diverse and hardworking team to grow together and realize our dreams.
        </p>
        <img src="/images/career-large.jpg" alt="career" />
      </div>

      <div className="Career-text">
        <h1>
          Everyday, Berymo technology protects lives by safely transporting people around their community. Berymo <br />is determined to help build stronger and safer<br />communities.
        </h1>
        <h5>Ali Goklukay, Berymo CTO</h5>
      </div>

         <div className="ram-section">
  <div className="ram-text">
    <h1>Diversity</h1>
    <p>
      Berymo aims to create a work environment that respects culture and diversity - where everyone, from our interns to our executives - can express themselves in a genuine way.
    </p>
  </div>
  <div className="ram-image">
    <img src="/images/career-diversity.jpg" alt="ram" />
  </div>

  <div className="ram-image">
    <img src="/images/career-culture.jpg" alt="ram" />
  </div>
  <div className="ram-text">
    <h1>Culture</h1>
    <p>
      Our team cultivates a positive work environment built upon hard work, transparency, and a dedication to our company’s mission - providing a valuable service to our customers and business partners through innovative technology and our solution-oriented approach to customer support.
    </p>
  </div>
</div>
      

      <div className="rama-image">
        <img src="/images/career-general.jpg" alt="rama" />
      </div>
     

      <div className="jobs-section">
  <h2>Jobs at Berymo</h2>
  <div className="jobs-grid">
    {jobs.map((job, index) => (
      <div className="job-card" key={index}>
        <h3>{job.title}</h3>
        <p>{job.location}</p>
      </div>
    ))}
  </div>
</div>


      

    </>
  );
};

export default Careers;
